export default "__VITE_ASSET__DdqJsPl1__"